import { z } from 'zod';

/** Zod schema used for form validation and error feedbacks */

const requiredMessage = 'Le champs est obligatoire';
const maxLenghtMessage = (max: number) => `Ce champs est limité à ${max} caractères`;

export const articleCategorySchema = z.object({
    libelle: z.string().trim().min(1, requiredMessage).max(255, maxLenghtMessage(255)),
    domainId: z.number({
        invalid_type_error: requiredMessage,
        required_error: requiredMessage,
    }),
});

export type ArticleCategorySchema = z.infer<typeof articleCategorySchema>;
